import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../elements/Header";
import { EnvContext } from "../../context/EnvContext";
import Footer from "../../elements/Footer";
import config from "../../config";
import { getAuth } from "firebase/auth";
import { useFirestore } from "../../firebase/FirestoreContext";
import { doc, getDoc } from "firebase/firestore";
import FAQ from "../../elements/FAQ";

const TermsOfService = ({ }) => {
  //
  const firestore = useFirestore();
  const environment = useContext(EnvContext);
  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;
  const location = useLocation();
  const contentRef = useRef(null);

  // Get FDA disclaimer data from the server /_DEVELOPMENT/stageapi/Help/Legal/Legal/LegalFDA legalContent and show as HTML content
  const [legalContent, setLegalContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLegalContent = async () => {
      try {
        const docRef = doc(firestore, `${collectionPath}Help/Legal/Legal`, "LegalTerms"); // Path to the document
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setLegalContent(data.legalContent); // Assuming the field in Firestore is named 'legalContent'
          setLoading(false);
        } else {
          console.log("No such document!");
          setError("No FDA Disclaimer found.");
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching legal content:", error);
        setError(error.message); // Set error state to the error message
        setLoading(false);
      }
    };

    fetchLegalContent();
  }, []);

  useEffect(() => {
    console.log("legalContent:", legalContent); // Check if legalContent has data
  }, [legalContent]);

  // Scroll to a numbered section when the URL hash is "#section-N".
  // The legal copy is server-rendered HTML with no anchor ids, so we
  // locate the heading by matching its leading "N." text.
  useEffect(() => {
    if (!legalContent || !contentRef.current) return;
    const match = (location.hash || "").match(/^#section-(\d+)$/);
    if (!match) return;
    const sectionNum = match[1];
    const candidates = contentRef.current.querySelectorAll(
      "h1, h2, h3, h4, h5, h6, p, strong, b, li"
    );
    const target = Array.from(candidates).find((el) => {
      const text = (el.textContent || "").trim();
      return new RegExp(`^${sectionNum}\\s*[\\.\\)\\:]`).test(text);
    });
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [legalContent, location.hash]);

  //
  return (
    <div>
      <Header />
      <div style={{ padding: "20px", maxWidth: "1140px", margin: "0 auto" }}>
        {legalContent && (
          <div
            ref={contentRef}
            style={{}}
            dangerouslySetInnerHTML={{ __html: legalContent }} // Render HTML content
          />
        )}
        <FAQ />
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfService;
